/*! RDB v2 — 3-step builder with popup, isolated */
(function () {
  'use strict';
  var root = document.getElementById('rdb-root');
  if (!root) return;

  // Add body class for CSS targeting
  document.body.classList.add('rdb-builder');

  function qs(s, r) {
    return (r || document).querySelector(s);
  }
  function qsa(s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  }
  function esc(s) {
    return String(s || '').replace(
      /[&<>"]/g,
      (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[m])
    );
  }
  function money(n) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'GBP',
      }).format(n);
    } catch (_) {
      return '£' + n.toFixed(2);
    }
  }

  var parentVariantId =
    Number(root.getAttribute('data-parent-variant-id')) || null;
  var feedAccessories = root.getAttribute('data-acc-feed') || '';
  var cache = Object.create(null);
  var state = { bottle: null, cap: null, reeds: null };
  var step = 1;

  function fetchJSON(url) {
    if (!url) return Promise.resolve([]);
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((j) => {
        cache[url] = Array.isArray(j.variants) ? j.variants : [];
        return cache[url];
      });
  }

  function group(items) {
    var g = { bottle: [], cap: [], reeds: [] };
    items.forEach((it) => {
      if (g[it.group]) g[it.group].push(it);
    });
    return g;
  }

  function card(it) {
    var dis = !it.available ? ' aria-disabled="true" data-disabled="1"' : '';
    var priceHtml = '';
    if (it.price !== undefined && it.price !== null) {
      // Price is already in pounds from the JSON feed
      priceHtml = '<div class="rdb-price">' + money(it.price) + '</div>';
    }
    return (
      '<button class="rdb-card" data-id="' +
      it.id +
      '" data-group="' +
      it.group +
      '" data-price="' +
      (it.price || 0) +
      '"' +
      dis +
      '>' +
      '<img src="' +
      esc(it.image) +
      '" alt="">' +
      '<div class="rdb-name">' +
      esc(it.product_title) +
      '</div>' +
      priceHtml +
      '</button>'
    );
  }

  function section(key, label, arr) {
    if (!arr.length) return '';
    return (
      '<div class="rdb-step" data-step="' +
      key +
      '">' +
      '<h3 class="rdb-title">' +
      label +
      '</h3>' +
      '<div class="rdb-grid">' +
      arr.map(card).join('') +
      '</div>' +
      '</div>'
    );
  }

  function stepIndicators() {
    return (
      '<div id="rdb-steps-anchor" class="rdb-steps-anchor"></div>' +
      '<div class="rdb-step-indicators">' +
      '<div class="rdb-step-indicator-wrapper">' +
      '<button class="rdb-step-indicator" data-step="bottle">' +
      '<div class="rdb-step-number">1</div>' +
      '<div class="rdb-step-label">PICK YOUR<br>BOTTLE</div>' +
      '</button>' +
      '<div class="rdb-step-preview" data-preview="bottle">' +
      '<div class="rdb-preview-arrow"></div>' +
      '<div class="rdb-preview-placeholder">Not selected</div>' +
      '</div>' +
      '</div>' +
      '<div class="rdb-step-indicator-wrapper">' +
      '<button class="rdb-step-indicator" data-step="cap">' +
      '<div class="rdb-step-number">2</div>' +
      '<div class="rdb-step-label">PICK YOUR<br>CAP</div>' +
      '</button>' +
      '<div class="rdb-step-preview" data-preview="cap">' +
      '<div class="rdb-preview-arrow"></div>' +
      '<div class="rdb-preview-placeholder">Not selected</div>' +
      '</div>' +
      '</div>' +
      '<div class="rdb-step-indicator-wrapper">' +
      '<button class="rdb-step-indicator" data-step="reeds">' +
      '<div class="rdb-step-number">3</div>' +
      '<div class="rdb-step-label">PICK YOUR<br>REEDS</div>' +
      '</button>' +
      '<div class="rdb-step-preview" data-preview="reeds">' +
      '<div class="rdb-preview-arrow"></div>' +
      '<div class="rdb-preview-placeholder">Not selected</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function render(items) {
    var g = group(items);
    root.innerHTML =
      stepIndicators() +
      '<div class="rdb-add-section">' +
      '<div class="rdb-instruction">Pick each part of your diffuser to enable the \'add to bag\' button.</div>' +
      '<button class="rdb-add-to-cart" id="rdb-add-to-cart" disabled>ADD TO CART...</button>' +
      '</div>' +
      section('bottle', '1. Pick your bottle', g.bottle) +
      section('cap', '2. Pick your cap', g.cap) +
      section('reeds', '3. Pick your reeds', g.reeds);
    activateStep('bottle');
  }

  function activateStep(k, shouldScroll) {
    qsa('.rdb-step', root).forEach((s) => s.classList.remove('active'));
    var el = qs('.rdb-step[data-step="' + k + '"]', root);
    if (el) el.classList.add('active');

    // Update step indicators
    qsa('.rdb-step-indicator', root).forEach((ind) =>
      ind.classList.remove('active')
    );
    var activeInd = qs('.rdb-step-indicator[data-step="' + k + '"]', root);
    if (activeInd) activeInd.classList.add('active');

    // Scroll to anchor if requested
    if (shouldScroll) {
      var anchor = qs('#rdb-steps-anchor', root);
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  function updatePreview(group) {
    var preview = qs('.rdb-step-preview[data-preview="' + group + '"]', root);
    if (!preview) return;

    if (state[group]) {
      preview.innerHTML =
        '<div class="rdb-preview-arrow"></div>' +
        '<img src="' +
        esc(state[group].img) +
        '" alt="Selected ' +
        group +
        '">';
      preview.classList.add('has-selection');
      preview.setAttribute('data-group', group);
    } else {
      preview.innerHTML =
        '<div class="rdb-preview-arrow"></div>' +
        '<div class="rdb-preview-placeholder">Not selected</div>';
      preview.classList.remove('has-selection');
      preview.removeAttribute('data-group');
    }

    // Update add to cart button state
    updateAddToCartButton();
  }

  function updateAddToCartButton() {
    var btn = qs('#rdb-add-to-cart', root);
    if (!btn) return;

    var allSelected = state.bottle && state.cap && state.reeds;
    btn.disabled = !allSelected;
  }

  function nextStep(current) {
    // Check if all steps are completed
    var allComplete = state.bottle && state.cap && state.reeds;

    if (current === 'bottle') {
      // Skip cap if already completed, go to reeds
      if (state.cap) {
        if (state.reeds) {
          // All complete, show popup or stay
          if (allComplete) {
            showPopup();
          }
        } else {
          activateStep('reeds', true);
        }
      } else {
        activateStep('cap', true);
      }
    } else if (current === 'cap') {
      // Skip reeds if already completed, go to bottle if needed
      if (state.reeds) {
        if (!state.bottle) {
          activateStep('bottle', true);
        } else if (allComplete) {
          // All complete
          showPopup();
        }
      } else {
        activateStep('reeds', true);
      }
    } else if (current === 'reeds') {
      // From last step, check if all complete
      if (allComplete) {
        showPopup();
      } else {
        // Go back to first incomplete step (circular)
        if (!state.bottle) {
          activateStep('bottle', true);
        } else if (!state.cap) {
          activateStep('cap', true);
        } else if (!state.reeds) {
          activateStep('reeds', true);
        }
      }
    }
  }

  // Use event delegation - single click handler on root
  function handleClick(e) {
    var target = e.target;

    // Traverse up to find clickable elements (handle clicks on child elements)
    while (target && target !== root) {
      // Handle product card click
      if (target.classList && target.classList.contains('rdb-card')) {
        e.preventDefault();
        e.stopPropagation();

        if (target.getAttribute('data-disabled') === '1') return;

        var g = target.getAttribute('data-group');
        var id = Number(target.getAttribute('data-id'));
        var price = Number(target.getAttribute('data-price')) || 0;
        state[g] = {
          id: id,
          title: target.querySelector('.rdb-name').textContent,
          img: target.querySelector('img').src,
          price: price,
        };

        // Remove previous selection in this group
        qsa('.rdb-step[data-step="' + g + '"] .rdb-card', root).forEach((x) =>
          x.classList.remove('rdb-selected')
        );

        // Add selected class and force repaint
        target.classList.add('rdb-selected');
        // Force browser reflow/repaint
        void target.offsetHeight;

        // Update the preview under the step indicator
        updatePreview(g);

        // Automatically advance to next step after a short delay
        setTimeout(function () {
          nextStep(g);
        }, 300);

        return;
      }

      // Handle step indicator click (check for the button or its children)
      if (target.classList && target.classList.contains('rdb-step-indicator')) {
        e.preventDefault();
        e.stopPropagation();

        var targetStep = target.getAttribute('data-step');
        if (targetStep) {
          activateStep(targetStep);
        }
        return;
      }

      // Handle Add to Cart button click
      if (target.id === 'rdb-add-to-cart' && !target.disabled) {
        e.preventDefault();
        e.stopPropagation();

        // Show the popup with selections
        showPopup();
        return;
      }

      // Check if we're inside a step indicator (clicked on number or label)
      var stepIndicator = target.closest('.rdb-step-indicator');
      if (stepIndicator) {
        e.preventDefault();
        e.stopPropagation();

        var targetStep = stepIndicator.getAttribute('data-step');
        if (targetStep) {
          activateStep(targetStep);
        }
        return;
      }

      // Handle click on preview (for remove via ::after pseudo-element)
      var previewBox = target.closest('.rdb-step-preview.has-selection');
      if (previewBox) {
        var rect = previewBox.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var clickY = e.clientY - rect.top;

        // Check if click is in the top-right corner (remove button area)
        // Button is at top: -14px, right: -14px, size: 28x28
        if (
          clickX >= rect.width - 14 &&
          clickX <= rect.width + 14 &&
          clickY >= -14 &&
          clickY <= 14
        ) {
          e.preventDefault();
          e.stopPropagation();

          var groupToRemove = previewBox.getAttribute('data-group');
          if (groupToRemove && state[groupToRemove]) {
            // Clear the state
            state[groupToRemove] = null;

            // Remove selected class from all cards in that group
            qsa(
              '.rdb-step[data-step="' + groupToRemove + '"] .rdb-card',
              root
            ).forEach((card) => card.classList.remove('rdb-selected'));

            // Update the preview
            updatePreview(groupToRemove);

            // Switch to the step where the product was removed
            activateStep(groupToRemove, true);
          }
          return;
        }
      }

      target = target.parentElement;
    }
  }

  function showPopup() {
    var overlay = document.createElement('div');
    overlay.id = 'rdb-overlay';
    overlay.innerHTML =
      '<div id="rdb-popup">' +
      '<h3>Your Diffuser Selections</h3>' +
      '<div class="rdb-popup-grid">' +
      popupItem(state.bottle) +
      popupItem(state.cap) +
      popupItem(state.reeds) +
      '</div>' +
      '<p style="color:#e75480;font-size:1.1em;margin-bottom:20px;">' +
      "We've added your Reed Diffuser Kit to the bag.<br>" +
      'Now Pick your free bottle of fragrance oil!' +
      '</p>' +
      '<button class="rdb-popup-btn" id="rdb-scent-btn">Pick your scent..</button>' +
      '</div>';
    document.body.appendChild(overlay);
    qs('#rdb-scent-btn', overlay).addEventListener('click', function (e) {
      e.preventDefault();
      try {
        localStorage.setItem(
          'RDB_PENDING',
          JSON.stringify({
            parent: parentVariantId,
            parts: {
              bottle: state.bottle ? state.bottle.id : null,
              cap: state.cap ? state.cap.id : null,
              reeds: state.reeds ? state.reeds.id : null,
            },
          })
        );
      } catch (_) {}
      window.location.href =
        '/collections/diffuser-refills-100ml?mz.show=In%20Stock';
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });
  }

  function popupItem(o) {
    if (!o) return '<div class="rdb-popup-item"></div>';
    var priceHtml = '';
    if (o.price) {
      // Price is already in pounds from state
      priceHtml = '<span class="rdb-popup-price">' + money(o.price) + '</span>';
    }
    return (
      '<div class="rdb-popup-item"><img src="' +
      esc(o.img) +
      '" alt=""><span>' +
      esc(o.title) +
      '</span>' +
      priceHtml +
      '</div>'
    );
  }

  // Bind single click handler using event delegation
  root.addEventListener('click', handleClick);

  fetchJSON(feedAccessories)
    .then(render)
    .catch(() => {
      root.innerHTML = '<p>Builder failed to load.</p>';
    });
})();
